// extracted by mini-css-extract-plugin
module.exports = {"main":"constructor-elements_main__HlZKa","optionalItems":"constructor-elements_optionalItems__3Do19"};